import Vue from 'vue'
import Router from 'vue-router'
import navigationGuard from './guards/navigation'

Vue.use(Router)

const routes = [
  /**
   * WELCOME AND LANDING
   */
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/Welcome.vue'),
    beforeEnter: navigationGuard.isLoggedOutGuard,
    meta: {
      layout: 'centered'
    }
  },

  /**
   * LOGIN AND AUTHENTICATION
   */
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    beforeEnter: navigationGuard.isLoggedOutGuard,
    meta: {
      layout: 'centered'
    }
  },

  /**
   * REGISTRATION FOR INVITED USERS
   */
  {
    path: '/register/:token',
    name: 'register',
    component: () => import('@/views/auth/Register.vue'),
    meta: {
      layout: 'centered'
    }
  },

  /**
   *  ADMIN DASHBOARD
   */
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/crm/dashboard/BaseDashboard.vue'),
    beforeEnter: navigationGuard.isLoggedInGuard,
    meta: {
      layout: 'crm'
    }
  },

  /**
   * CUSTOMERS
   */
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/crm/customers/Customers.vue'),
    meta: {
      layout: 'crm',
      permission: 'customers.list'
    }
  },

  {
    path: '/customers/:customer_id',
    redirect: { name: 'customer' },
    component: () => import('@/views/crm/customers/Customer.vue'),
    meta: {
      layout: 'crm'
    },
    children: [
      {
        path: 'overview',
        name: 'customer',
        beforeEnter: navigationGuard.hasPermissionGuard,
        component: () => import('@/views/crm/customers/CustomerOverview.vue'),
        meta: {
          permission: 'customers.view'
        }
      },

      {
        path: 'settings',
        name: 'customer.settings',
        component: () => import('@/views/crm/customers/CustomerSettings.vue'),
        beforeEnter: navigationGuard.hasPermissionGuard,
        meta: {
          permission: 'customers.settings'
        }
      }
    ]
  },

  /**
   * PROJECTS
   */
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/views/crm/projects/Projects.vue'),
    beforeEnter: navigationGuard.hasPermissionGuard,
    meta: {
      layout: 'crm',
      permission: 'projects.list'
    }
  },

  {
    path: '/projects/:project_id',
    redirect: { name: 'project' },
    component: () => import('@/views/crm/projects/Project.vue'),
    meta: {
      layout: 'crm'
    },
    children: [
      {
        path: 'overview',
        name: 'project',
        beforeEnter: navigationGuard.hasPermissionGuard,
        component: () => import('@/views/crm/projects/ProjectOverview.vue'),
        meta: {
          permission: 'projects.view'
        }
      },

      {
        path: 'settings',
        name: 'project.settings',
        component: () => import('@/views/crm/projects/ProjectSettings.vue'),
        beforeEnter: navigationGuard.hasPermissionGuard,
        meta: {
          permission: 'projects.settings'
        }
      },

      {
        path: 'members',
        name: 'project.members',
        component: () => import('@/views/crm/projects/ProjectMembers.vue'),
        beforeEnter: navigationGuard.hasPermissionGuard,
        meta: {
          permission: 'projects.members'
        }
      },

      {
        path: 'documents',
        name: 'project.documents',
        component: () => import('@/views/crm/projects/ProjectDocuments.vue'),
        beforeEnter: navigationGuard.hasPermissionGuard,
        meta: {
          permission: 'projects.documents'
        }
      }
    ]
  },

  /**
   * TASK LISTS
   */
  {
    path: '/tasklists/:task_list_id',
    name: 'tasklist',
    component: () => import('@/views/crm/tasks/TaskList.vue'),
    beforeEnter: navigationGuard.hasPermissionGuard,
    meta: {
      layout: 'crm',
      permission: 'tasklists.list'
    }
  },

  /**
   * TASKS
   */
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/views/crm/tasks/Tasks.vue'),
    beforeEnter: navigationGuard.hasPermissionGuard,
    meta: {
      layout: 'crm',
      permission: 'tasks.list'
    }
  },

  {
    path: '/tasks/:task_id',
    name: 'task',
    component: () => import('@/views/crm/tasks/Task.vue'),
    beforeEnter: navigationGuard.hasPermissionGuard,
    meta: {
      layout: 'crm',
      permisson: 'tasks.view'
    }
  },

  /**
   * WORKERS
   */
  {
    path: '/workers',
    name: 'workers',
    component: () => import('@/views/crm/workers/Workers.vue'),
    beforeEnter: navigationGuard.hasPermissionGuard,
    meta: {
      layout: 'crm',
      permission: 'workers.list'
    }
  }
]

routes.push({
  path: '*',
  name: '404',
  component: () => import('@/views/error/NotFound.vue'),
  meta: {
    layout: 'centered'
  }
})

routes.push({
  path: '/permission-denied',
  name: '403',
  component: () => import('@/views/error/NotAuthorized.vue'),
  meta: {
    layout: 'centered'
  }
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
